<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="[pageName]"></ch-breadcrumb>
  <form (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="offer-type-edit-position">Images (390x390)</label>
                <div class="row">
                  <div class="col-sm-3 col-md-3">
                    <ch-image-upload
                      (onChange)="homeIconChanged($event)"
                      [resourceId]="offerTypeData.iconId"
                      [square]="true"
                      [maxWidth]="390"
                      [maxHeight]="390"
                    ></ch-image-upload>
                  </div>
                  <div class="col-sm-3 col-md-3">
                    <ch-image-upload
                      (onChange)="homeIconSelectedChanged($event)"
                      [resourceId]="offerTypeData.iconSelectedId"
                      [square]="true"
                      [maxWidth]="390"
                      [maxHeight]="390"
                    ></ch-image-upload>
                  </div>
                </div>
              </div>

              <div class="text-danger">{{ error }}</div>

              <div style="margin-top: 40px;">
                <span class="btn-right">
                  <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offer-types/offer-type-edit/manage-icon/manage-icon.component.html